/**
 * Notification preferences types.
 * Controls user settings for email notifications, trading reminders, and marketing.
 */

export interface NotificationPreferences {
  // Email notifications
  emailEnabled: boolean;
  weeklyReportEmail: boolean;
  tradingInsightsEmail: boolean;
  productUpdatesEmail: boolean;

  // In-app reminders
  dailyJournalReminder: boolean;
  dailyJournalReminderTime?: string; // HH:MM format, user's timezone

  // Trading reminders
  marketOpenReminder: boolean;
  marketCloseReminder: boolean;

  // Marketing
  marketingEmails: boolean;
}

export const DEFAULT_NOTIFICATION_PREFERENCES: NotificationPreferences = {
  emailEnabled: true,
  weeklyReportEmail: true,
  tradingInsightsEmail: true,
  productUpdatesEmail: true,
  dailyJournalReminder: false,
  marketOpenReminder: false,
  marketCloseReminder: false,
  marketingEmails: false,
};
